export default "__VITE_ASSET__RiL0JMvz__"